import Calificate from "./Calificate";
import Criterion from "./Criterion";
import SubCriterion from "./SubCriterion";

const items = { Calificate, Criterion, SubCriterion };

export default items;
